import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useEditHealthCheckMutation } from '../../../generated/graphql';
import { FormField, FormTextArea } from '../../form';
import styles from './EditHealthCheckDialog.module.css';

type EditHealthCheckDialogProps = {
    onClose: () => void,
    id: string,
    name: string,
    group: string,
    display: string,
    limit: number,
    description: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const EditHealthCheckDialog = (props: EditHealthCheckDialogProps) => {
    const { id, style, visible, onClose } = props;
    const [editHealthCheck, editHealthCheckResult] = useEditHealthCheckMutation();
    const [name, setName] = useState(props.name || '');
    const [group, setGroup] = useState(props.group || '');
    const [display, setDisplay] = useState(props.display || '');
    const [limit, setLimit] = useState(String(props.limit ?? ''));
    const [description, setDescription] = useState(props.description || '');
    const [validationError, setValidationError] = useState('');

    const handleSubmit = () => {
        if (!name || !group || !display || !limit || !description) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        editHealthCheck({
            variables: {
                healthCheckId: id,
                name,
                group,
                display,
                limit: Number.parseInt(limit),
                description,
            }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Edit Health Check"
            type="OkCancel"
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            isLoading={editHealthCheckResult.loading}
            className={styles.EditHealthCheckDialog}
            style={style}
            data-testid="EditHealthCheckDialog">
            <FormField label="Name" name="name" value={name} onChange={setName} />
            <FormField label="Group" name="group" value={group} onChange={setGroup} />
            <FormField label="Display" name="display" value={display} onChange={setDisplay} />
            <FormField label="Limit" name="limit" type="number" value={limit} onChange={setLimit} />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} />
        </DialogBase>
    );
};

export default EditHealthCheckDialog;
